import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./Header.scss";
import { useSelector, useDispatch } from 'react-redux'
import { triviaQuestionsById, clearTrivia } from '../../store/TriviaRedux'
import { singleUser, getNotifications } from '../../store/UserRedux'
import Nav from "./Nav";
import NavMob from "./NavMob";

export default function Header() {
  const history = useHistory();
  const dispatch = useDispatch()
  const token = useSelector((state) => state.auth.token)
  const currentUser = useSelector((state) => state.auth.user)
  const userDetails = useSelector((state) => state.user.userDetails)
  const questions = useSelector((state) => state.trivia.questions)

  useEffect(() => {
    if (currentUser) {
      dispatch(singleUser({ id: currentUser._id, token }));
      dispatch(getNotifications({ token }))
    }
  }, [currentUser]);

  useEffect(() => {
    if (userDetails && userDetails.activeContest && userDetails.activeContest.contestantId) {
      let params = { contestantId: `${userDetails.activeContest.contestantId}`, token }
      dispatch(triviaQuestionsById(params))
    } else {
      dispatch(clearTrivia())
    }
  }, [userDetails]);

  useEffect(() => {
    if (userDetails && userDetails.activeContest) {
      if (questions && questions.lastStep == -1) {
        history.push("/beforecontestgiftcard");
      } else if (questions) {
        history.push("/StartContest");
      }
    }
  }, [questions]);

  return <>
    <div className="destops"><Nav /></div>
    <div className="mobiles"><NavMob /></div>
  </>
};

